import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ContentService } from '../../services/aem/content.service';
import * as AEMActions from '../actions/content.actions';

@Injectable()
export class ContentEffects {
  loadContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMContent),
      switchMap(() =>
        this.content.getContent().pipe(
          map((content) =>
            AEMActions.loadAEMContentSuccess({
              aemContent: {
                id: 'aem-content',
                aemContent: content
              }
            })
          ),
          catchError(() =>
            of(
              AEMActions.loadAEMContentFailure({
                aemContentError: {
                  id: 'aem-content-error',
                  aemContentError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly content: ContentService
  ) {}
}
